import { render } from "./SectionGuide.vue?vue&type=template&id=049e1efa&scoped=true"
import script from "./SectionGuide.vue?vue&type=script&lang=js"
export * from "./SectionGuide.vue?vue&type=script&lang=js"

import "./SectionGuide.vue?vue&type=style&index=0&id=049e1efa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049e1efa"]])

export default __exports__